import React, { useState, useEffect } from "react";
import api from "../api";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";

const CreateProjectModal = ({ project, onClose }) => {
  const isEditing = Boolean(project);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (project) {
      setName(project.name || "");
      setDescription(project.description || "");
    }
  }, [project]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) {
      showErrorToast("Project name is required");
      return;
    }

    setSubmitting(true);
    try {
      if (isEditing) {
        await api.put(`/projects/${project.project_id}`, {
          name: trimmedName,
          description: description.trim(),
        });
        showSuccessToast("Project updated");
      } else {
        await api.post("/projects", {
          name: trimmedName,
          description: description.trim(),
        });
        showSuccessToast("Project created");
      }
      onClose(true);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        (isEditing ? "Failed to update project" : "Failed to create project");
      showErrorToast(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="modal modal-backdrop-custom d-block custom-ak-scollbar"
      tabIndex="-1"
    >
      <div
        // className="modal-dialog modal-dialog-centered"
        className="m-auto d-flex flex-1"
        style={{ minHeight: "100vh" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title ak-text-lg">
              {isEditing ? "Edit Project" : "Create Project"}
            </h5>
            <button
              type="button"
              className="btn-close border border-dark rounded-circle ak-text-sm"
              onClick={() => onClose(false)}
              disabled={submitting}
            />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label ak-text-lg">
                  Project Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type Project name "
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  maxLength={200}
                  autoFocus
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label ak-text-lg">Describe</label>
                <textarea
                  className="form-control custom-ak-scollbar"
                  placeholder="Describe your project"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  maxLength={2000}
                  rows={3}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="cancle-btn"
                onClick={() => onClose(false)}
                disabled={submitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="custom-btn"
                disabled={submitting || !name.trim()}
              >
                {submitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    />
                    {isEditing ? "Saving..." : "Creating..."}
                  </>
                ) : isEditing ? (
                  "Save Changes"
                ) : (
                  "Create Project"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectModal;
